import {FC} from "react";
import type { Complaint } from "./schema";
import {wrapClick, dispatchModal, closeModal} from "utils";
import ViewServiceFeedbackContainer from "../service-feedback/view";
import {useSearch} from "react-location";

type FeedbackContainerProps = {
  complaint: Complaint
}

const FeedbackContainer: FC<FeedbackContainerProps> = ({
 complaint,
}) => {

  const searchParams = useSearch();

  return (
    <div className="bg-white shadow sm:rounded-lg">
      <div className="px-4 py-5 sm:p-6 flex gap-4 ">
        <div className={"flex-1"}>
          <h3 className="text-lg font-medium text-gray-900">
            Customer Feedback
          </h3>
          {
            complaint?.reviewSubmitted ? (
              <div className="flex flex-col gap-4">
                <p
                  className="text-sm font-medium text-gray-700 mt-1">
                  Feedback Submitted
                </p>
              </div>
            ) : (
              <div className="flex flex-col gap-4">
                <p
                  className="text-sm font-medium text-gray-700 mt-1">
                  Feedback is pending
                </p>
              </div>
            )
          }
        </div>
        <div className={"flex-shrink-0 grid place-items-center"}>
          <button
            type='button'
            className='w-full disabled:cursor-not-allowed disabled:bg-primary-600/60 disabled:hover:bg-primary-600/50 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm'
            disabled={!complaint.reviewSubmitted}
            onClick={wrapClick(dispatchModal(complaint.review?._id ,"view-feedback"))}
          >
            View Feedback
          </button>
        </div>
      </div>
      <ViewServiceFeedbackContainer
        open={searchParams.modal === 'view-feedback'}
        setOpen={(val) => {
          if(val){
            dispatchModal(complaint.review?._id ,"view-feedback")
          } else {
            closeModal()
          }
        }}
        id={complaint.review?._id}
      />
    </div>
  )
}

export default FeedbackContainer;